import { InvoiceManualLine } from "./invoice-manual-line";

export class InvoiceManual {
    id: string;
    invoiceNumber: string;
    cai: string;
    date: string;
    condition: string;
    taxType: string;
    salesOrg: string;
    contractNumber: string;
    invoiceLines: Array<InvoiceManualLine>;
    constructor() {
        this.id = "";
        this.invoiceNumber = "";
        this.cai = "";
        this.date = "";
        this.condition = "";
        this.taxType = "";
        this.salesOrg = "";
        this.contractNumber = "";
        this.invoiceLines = [];
    }
}